import {
  AlertSocket,
  GetAlertDTO,
  GetAlertUpdateDTO,
  Reminder,
  ReminderAction,
  StatusSettings,
} from ".";
import { UserNearVitals } from "../../redux/devicesStatuses";
import { ResolveAlert } from "../modalFeedback/index";
import { residentsReqOptions } from "../residents";
import {
  IDeleteResidentBySocket,
  IUpdateResidentBySocket,
} from "../residents/types";

export enum ALERTS {
  HANDLE_REQUEST = "ALERTS.HANDLE_REQUEST",
  HANDLE_SUCCESS = "ALERTS.HANDLE_SUCCESS",
  HANDLE_FAILURE = "ALERTS.HANDLE_FAILURE",

  GET_ALERTS_BY_RESIDENT_ID_REQUEST = "ALERTS.GET_ALERTS_BY_RESIDENT_ID_REQUEST",
  GET_ALERTS_BY_RESIDENT_ID_SUCSSESS = "ALERTS.GET_ALERTS_BY_RESIDENT_ID_SUCSSESS",
  GET_ALERTS_BY_RESIDENT_ID_FAILURE = "ALERTS.GET_ALERTS_BY_RESIDENT_ID_FAILURE",

  GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST = "ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST",
  GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS = "ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS",
  GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE = "ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE",

  SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST = "ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST",
  SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS = "ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS",
  SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE = "ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE",

  GET_ALERTS_FROM_RESIDENT_REQUEST = "ALERTS.GET_ALERTS_FROM_RESIDENT_REQUEST",
  GET_ALERTS_FROM_RESIDENT_SUCCESS = "ALERTS.GET_ALERTS_FROM_RESIDENT_SUCCESS",
  GET_ALERTS_FROM_RESIDENT_FAILURE = "ALERTS.GET_ALERTS_FROM_RESIDENT_FAILURE",
  SET_MONITOR_ALERTS_SETTINGS = "ALERTS.SET_MONITOR_ALERTS_SETTINGS",
  SET_MONITOR_STATUS_SETTINGS = "ALERTS.SET_MONITOR_STATUS_SETTINGS",

  GET_NEW_ALERT_BY_SOCKET = "ALERTS.GET_NEW_ALERT_BY_SOCKET",

  GET_NEW_REMINDER_BY_SOCKET = "ALERTS.GET_NEW_REMINDER_BY_SOCKET",
  GET_REMINDER_MISSED_BY_SOCKET = "ALERTS.GET_REMINDER_MISSED_BY_SOCKET",
  GET_REMINDER_HANDLED_BY_SOCKET = "ALERTS.GET_REMINDER_HANDLED_BY_SOCKET",

  GET_USER_NEARBY_BY_SOCKET = "ALERTS.GET_USER_NEARBY_BY_SOCKET",
}

export interface IAlertHandleRequest {
  type: typeof ALERTS.HANDLE_REQUEST;
  payload: { alertId: string; feedback: any };
}
export interface IAlertHandleSuccess {
  type: typeof ALERTS.HANDLE_SUCCESS;
  payload: any;
}
export interface IAlertHandleFailure {
  type: typeof ALERTS.HANDLE_FAILURE;
  payload: any;
}

export interface IGetAlertByIdRequest {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_REQUEST;
  payload: GetAlertDTO;
}
export interface IGetAlertByIdSuccess {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_SUCSSESS;
  payload: GetAlertUpdateDTO[];
}
export interface IGetAlertByIdFailure {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_FAILURE;
  payload: any;
}

export interface IGetAlertByIdRequest {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_REQUEST;
  payload: GetAlertDTO;
}
export interface IGetAlertByIdSuccess {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_SUCSSESS;
  payload: GetAlertUpdateDTO[];
}
export interface IGetAlertByIdFailure {
  type: typeof ALERTS.GET_ALERTS_BY_RESIDENT_ID_FAILURE;
  payload: any;
}

export interface IGetAlertsFromResidentRequest {
  type: typeof ALERTS.GET_ALERTS_FROM_RESIDENT_REQUEST;
  payload: residentsReqOptions;
}
export interface IGetAlertsFromResidentSuccess {
  type: typeof ALERTS.GET_ALERTS_FROM_RESIDENT_SUCCESS;
  payload: any;
}
export interface IGetAlertsFromResidentFailure {
  type: typeof ALERTS.GET_ALERTS_FROM_RESIDENT_FAILURE;
  payload: any;
}

export interface ISetMonitorAlertsSettings {
  type: typeof ALERTS.SET_MONITOR_ALERTS_SETTINGS;
  payload: StatusSettings;
}
export interface IGetNewAlertBySocket {
  type: typeof ALERTS.GET_NEW_ALERT_BY_SOCKET;
  payload: AlertSocket;
}

export interface ISetAlertByTypeAndResidentSuccess {
  type: typeof ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS;
  payload: ResolveAlert;
}

export interface IGetNewReminderBySocket {
  type: typeof ALERTS.GET_NEW_REMINDER_BY_SOCKET;
  payload: Reminder;
}

export interface IGetReminderMissedBySocket {
  type: typeof ALERTS.GET_REMINDER_MISSED_BY_SOCKET;
  payload: ReminderAction;
}

export interface IGetReminderHandledBySocket {
  type: typeof ALERTS.GET_REMINDER_HANDLED_BY_SOCKET;
  payload: ReminderAction;
}

export interface IGetUserNearbyBySocket {
  type: typeof ALERTS.GET_USER_NEARBY_BY_SOCKET;
  payload: {
    deviceId: string;
    data: UserNearVitals[];
    room: string;
    bed: string;
  };
}

export type AlertActionType =
  | IGetUserNearbyBySocket
  | IAlertHandleRequest
  | IAlertHandleSuccess
  | IAlertHandleFailure
  | IGetAlertByIdRequest
  | IGetAlertByIdSuccess
  | IGetAlertByIdFailure
  | IGetAlertsFromResidentRequest
  | IGetAlertsFromResidentSuccess
  | IGetAlertsFromResidentFailure
  | ISetMonitorAlertsSettings
  | IGetNewAlertBySocket
  | IDeleteResidentBySocket
  | IUpdateResidentBySocket
  | IGetNewReminderBySocket
  | IGetReminderHandledBySocket
  | IGetReminderMissedBySocket
  | ISetAlertByTypeAndResidentSuccess;
